/**
 * Full-page navigation out of the app, such as the hand-off to Google's
 * sign-in. It lives in its own module so tests can observe the hand-off:
 * jsdom cannot perform a cross-origin navigation.
 */
export function leaveAppTo(url: string): void {
  window.location.assign(url);
}
